<script>
import {mapGetters} from 'vuex'
import UploadServicesTab from '@/components/profile/tabs/UploadServicesTab.vue'
import CreditTab from '@/components/profile/tabs/CreditTab.vue'
import PrintParametersTab from '@/components/profile/tabs/PrintParametersTab.vue'
import ShippingOptionsTab from '@/components/profile/tabs/ShippingOptionsTab.vue'
import DocumentChecksTab from '@/components/profile/tabs/DocumentChecksTab.vue'
import DataCleaning from '@/components/profile/generally/DataCleaning.vue'
// import TableSettingsTab from '@/components/settings/TableSettingsTab.vue'

export default {
  components: {
    DataCleaning,
    // TableSettingsTab,
    CreditTab,
    DocumentChecksTab,
    ShippingOptionsTab,
    UploadServicesTab,
    PrintParametersTab
  },
  data() {
    return {
      activeTab: 0
    }
  },
  computed: {
    ...mapGetters(['isLocked']),
  },
  created() {
    this.$store.dispatch('getUserSettings')
  }
}
</script>
<template>
  <v-container fluid>
    <v-card>
      <v-tabs v-model="activeTab" show-arrows>
        <v-tabs-slider></v-tabs-slider>
        <!--        <v-tab>-->
        <!--          <v-icon>mdi-table</v-icon>-->
        <!--          <span class="pl-1">{{$t('page.settings.view.tabs.tables')}}</span>-->
        <!--        </v-tab>-->
        <v-tab>
          <v-icon>mdi-cloud-sync-outline</v-icon>
          <span class="pl-1">{{ $t('page.settings.view.tabs.uploadServices') }}</span>
        </v-tab>
        <!--        LEGACY MODULE-->
        <v-tab v-if="false">
          <v-icon>mdi-cash-check</v-icon>
          <span class="pl-1">{{ $t('page.settings.view.tabs.credit') }}</span>
        </v-tab>
        <v-tab>
          <v-icon v-if="isLocked">mdi-lock-outline</v-icon>
          <v-icon v-else>mdi-printer-outline</v-icon>
          <span class="pl-1">{{ $t('page.settings.view.tabs.printParameters') }}</span>
        </v-tab>
        <v-tab v-if="$permissions.hasOrderAutocomplete && !isLocked">
          <v-icon>mdi-send-check-outline</v-icon>
          <span class="pl-1">{{ $t('page.settings.view.tabs.shippingOptions') }}</span>
        </v-tab>
        <v-tab>
          <v-icon>mdi-text-box-check-outline</v-icon>
          <span class="pl-1">{{ $t('page.settings.view.tabs.documentChecks') }}</span>
        </v-tab>
        <v-tab>
          <v-icon>mdi-database-remove</v-icon>
          <span class="pl-1">{{ $t('page.settings.view.tabs.dataCleaning') }}</span>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="activeTab">
        <!--        <v-tab-item>-->
        <!--          <v-divider />-->
        <!--          <v-container fluid>-->
        <!--            <v-row>-->
        <!--              <v-col>-->
        <!--                <TableSettingsTab />-->
        <!--              </v-col>-->
        <!--            </v-row>-->
        <!--          </v-container>-->
        <!--        </v-tab-item>-->
        <v-tab-item>
          <v-divider/>
          <UploadServicesTab/>
        </v-tab-item>
        <!--        LEGACY MODULE-->
        <v-tab-item v-if="false">
          <v-divider/>
          <CreditTab/>
        </v-tab-item>
        <v-tab-item>
          <v-divider/>
          <PrintParametersTab/>
        </v-tab-item>
        <v-tab-item v-if="$permissions.hasOrderAutocomplete">
          <v-divider/>
          <ShippingOptionsTab/>
        </v-tab-item>
        <v-tab-item>
          <v-divider/>
          <DocumentChecksTab/>
        </v-tab-item>
        <v-tab-item>
          <v-divider/>
          <DataCleaning/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>
